<div class="action-tablet">

  <sc-flex vertical fitHeight stretchContent>
    <ng-container *ngIf="enableStationSelectionHeader">
      <app-action-tablet-header [actionTabletContext]="actionTabletContext"></app-action-tablet-header>
      <sc-content-spacer vertical></sc-content-spacer>
    </ng-container>

    <sc-flex-fitting-content vertical>

      <sc-tab-group>

        <sc-tab iconCss="fa-desktop" titleDictionaryKey="tmc-yard.action-tablet.station-transport-details.title">
          <sc-content-spacer vertical></sc-content-spacer>
          <app-action-tablet-station-details
            [stationId]="actionTabletContext.currentlyActiveStation"></app-action-tablet-station-details>
        </sc-tab>

        <sc-tab iconCss="fa-truck-flatbed" titleDictionaryKey="tmc-yard.action-tablet.waiting-movement-orders.title">
          <sc-content-spacer vertical></sc-content-spacer>
          <app-action-tablet-waiting-movement-orders
            [movementOrders]="waitingMovementOrders"></app-action-tablet-waiting-movement-orders>
        </sc-tab>

      </sc-tab-group>

    </sc-flex-fitting-content>

  </sc-flex>

</div>
